// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3QZdysF20Wjc5GrtL7XFZr {\n    margin-top: 5px;\n    border: 4px solid #86C232;\n    border-radius: 15px;\n    background: rgba(241, 235, 235, 0.959)\n}\n\n.hU2-0caS0jy-ZT6FuK5WY {\n    border-radius: 15px;\n}", "",{"version":3,"sources":["SearchBar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;AACvB","file":"SearchBar.css","sourcesContent":[".searchBar {\n    margin-top: 5px;\n    border: 4px solid #86C232;\n    border-radius: 15px;\n    background: rgba(241, 235, 235, 0.959)\n}\n\n.textField {\n    border-radius: 15px;\n}"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchBar": "_3QZdysF20Wjc5GrtL7XFZr",
	"textField": "hU2-0caS0jy-ZT6FuK5WY"
};
export default ___CSS_LOADER_EXPORT___;
